// extracted by mini-css-extract-plugin
export default {"loading_icon":"LoadingIcon_loading_icon__BAzBX"};